'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _commonFunctions = require('../../helpers/commonFunctions');

function populateCoverageData(context, data) {
  context.updateProp('application.additional_data.policy_type', data.additional_data.policy_type);
  context.updateProp('application.additional_data.destination', data.additional_data.destination);
  context.updateProp('application.additional_data.trip_cost', data.additional_data.trip_cost);
  context.updateProp('application.additional_data.cancel_delux', data.additional_data.cancel_delux);
  context.updateProp('application.additional_data.country_of_origin', data.additional_data.country_of_origin);
  context.updateProp('application.additional_data.province_of_residence', data.additional_data.province_of_residence);
  context.updateProp('application.additional_data.membership_number', data.additional_data.membership_number);
  context.updateProp('application.additional_data.trip_booked_date', data.additional_data.trip_booked_date);
  context.updateProp('application.additional_data.number_of_days_per_trip', data.additional_data.number_of_days_per_trip);
  (0, _commonFunctions.populateEligibility)(context, data);
}

exports.default = function (context) {
  (0, _commonFunctions.populateQuoteData)(context, populateCoverageData);
};


//////////////////
// WEBPACK FOOTER
// ./src/v2/transformers/all-inclusive/quote.js
// module id = 1738
// module chunks = 0